import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import StarIcon from '@mui/icons-material/Star';

const CurrentChallengeStreakCard = (challengeData = {}) => {
  const [data, setData] = useState(challengeData);

  useEffect(() => {
    setData(challengeData.challengeData);
  }, [challengeData]);

  useEffect(() => {
    if (Object.keys(data).length === 0) {
      setData({
        weekStreak: 3,
      });
    }
  }, [data]);

  return (
    <Box
      id="current-challenge-streak-card"
      sx={{
        border: '1px solid grey',
        borderRadius: '10px',
        display: 'flex',
        width: '316px',
        height: '237px',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          height: '125px',
          padding: '24px 32px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: '32px',
          flexShrink: 0,
          alignSelf: 'stretch',
          background: 'var(--Gray-gray2, #F8F8F8)',
        }}
      >
        <Box
          id="current-challenge-right-box"
          sx={{
            // border: '1px solid black',
            width: '230.08px',
            height: '74px',
            gap: '19px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            id="fire-icon-box"
            sx={{
              width: '74px',
              height: '74px',
              padding: '0px',
              gap: '7.12px',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#E1DDED',
            }}
          >
            <WhatshotIcon size={40} />
          </Box>
          <Box
            id="streak-info"
            sx={{
              width: '102px',
              height: '62px',
              gap: '8px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                width: '29px',
                height: '34px',
                gap: '0px',
                fontFamily: 'Montserrat',
                fontSize: '48px',
                fontWeight: 700,
                lineHeight: '58.51px',
                textAlign: 'left',
                textUnderlinePosition: 'from-font',
                textDecorationSkipInk: 'none',
              }}
            >
              {data.weekStreak}
            </Typography>
            <Typography
              sx={{
                marginTop: '5px',
                width: '102px',
                height: '20px',
                gap: '0px',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '19.5px',
                textAlign: 'left',
                textUnderlinePosition: 'from-font',
                textDecorationSkipInk: 'none',
              }}
            >
              Week Streak
            </Typography>
          </Box>
        </Box>
        {/* Add any content you want inside this box */}
      </Box>
      <Box
        id="streak-note"
        sx={{
          display: 'flex',
          padding: '24px 40px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '12px',
          flex: '1 0 0',
          alignSelf: 'stretch',
        }}
      >
        <StarIcon
          style={{
            width: 'var(--1, 20px)',
            height: 'var(--1, 20px)',
            transform: 'rotate(-0.059deg)',
          }}
        />
        <Typography
          sx={{
            color: '#000',
            textAlign: 'center',
            fontFamily: 'Montserrat',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
          }}
        >
          You're a
        </Typography>
        <Typography
          sx={{
            color: '#000',
            fontFamily: 'Montserrat',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
          }}
        >
          Rock Star!
        </Typography>
      </Box>
    </Box>
  );
};

export default CurrentChallengeStreakCard;
